import { IConfig } from '@cian/config/shared';
import { useSelector } from 'react-redux';

import { selectExperiments } from '../../../selectors/experiments';
import { useApplicationContext } from '../../applicationContext';
import { isExperimentActive } from '../getExperiment';

export const RS_EXPERIMENT_NAME = 'dailyrent.fastFiltersRedesignExpName';
export const EXPERIMENT_ENABLED_GROUP = 'test';

// @todo выпилить эксп https://jira.cian.tech/browse/CD-185110
// + не забыть убрать RS из scheme.json!

export const getDailyrentFastFiltersRedesignExpName = (config: IConfig) => {
  return config.get<string>(RS_EXPERIMENT_NAME) || '';
};

export const useIsDailyrentFastFiltersRedesignExpEnabled = () => {
  const { config } = useApplicationContext();
  const experiments = useSelector(selectExperiments);
  const experimentName = getDailyrentFastFiltersRedesignExpName(config);

  return isExperimentActive(experiments, experimentName, EXPERIMENT_ENABLED_GROUP);
};
